/**
 * Styling Tips — open Shopify-hosted videos in a modal player.
 */
(function () {
  function clearPlayer(player) {
    if (!player) return;
    const video = player.querySelector('video');
    if (video) {
      video.pause();
      video.removeAttribute('src');
      video.load();
    }
    player.innerHTML = '';
  }

  function openVideoModal(trigger) {
    const templateId = trigger.getAttribute('data-video-template');
    const modalId = trigger.getAttribute('aria-controls');
    if (!templateId || !modalId) return;

    const template = document.getElementById(templateId);
    const modal = document.getElementById(modalId);
    if (!template || !modal) return;

    const player = modal.querySelector('[data-blog-video-player]');
    if (!player) return;

    clearPlayer(player);

    const clone = template.content.cloneNode(true);
    player.appendChild(clone);

    const video = player.querySelector('video');
    if (video) {
      video.setAttribute('controls', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('autoplay', '');
      video.muted = false;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          video.muted = true;
          video.play().catch(function () {});
        });
      }
      video.focus();
    }

    if (typeof modal.open === 'function') {
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      modal.open(trigger);
    } else {
      modal.setAttribute('open', '');
    }
  }

  function handleTriggerClick(event) {
    const trigger = event.target.closest('[data-blog-video-trigger]');
    if (!trigger) return;
    event.preventDefault();
    openVideoModal(trigger);
  }

  function handleModalClose(modal) {
    const player = modal.querySelector('[data-blog-video-player]');
    clearPlayer(player);
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
    const caption = modal.querySelector('[data-blog-video-caption]');
    if (caption) {
      caption.textContent = '';
      caption.hidden = true;
    }
  }

  document.addEventListener('click', handleTriggerClick);

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    const openModal = document.querySelector('.blog-video-modal[open]');
    if (openModal) handleModalClose(openModal);
  });

  document.querySelectorAll('.blog-video-modal').forEach((modal) => {
    modal.addEventListener('click', (event) => {
      if (event.target === modal || event.target.closest('.js-close-modal')) {
        handleModalClose(modal);
      }
    });
  });
})();
